import styled, { createGlobalStyle } from "styled-components";

/**
 * Global because react-responsive-modal portals the dialog outside the
 * local styled wrapper — descendant selectors would never match.
 */
export const ModalConsultGlobalStyle = createGlobalStyle`
  .react-responsive-modal-container.visitDetailsModalContainer {
    height: 100%;
    overflow: hidden !important;
    text-align: center !important;
    padding: 0.75rem;
    box-sizing: border-box;
  }

  .react-responsive-modal-container.visitDetailsModalContainer.react-responsive-modal-containerCenter:after {
    width: 0;
    height: 100%;
    content: "";
    display: inline-block !important;
    vertical-align: middle;
  }

  .react-responsive-modal-modal.visitDetailsModal {
    display: inline-flex !important;
    flex-direction: column;
    width: min(920px, calc(100vw - 1.5rem)) !important;
    max-width: 920px !important;
    height: auto !important;
    max-height: min(90vh, 900px) !important;
    max-height: min(90dvh, 900px) !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    background: #ffffff;
    box-shadow: 0 20px 40px rgba(15, 23, 42, 0.16);
    vertical-align: middle;
    text-align: left;
    box-sizing: border-box;
  }

  .react-responsive-modal-modal.visitDetailsModal .react-responsive-modal-closeButton {
    top: 14px;
    right: 14px;
    z-index: 2;
  }

  @media (max-width: 767px) {
    .react-responsive-modal-container.visitDetailsModalContainer {
      padding: 0.5rem;
    }

    .react-responsive-modal-modal.visitDetailsModal {
      width: 100% !important;
      max-width: none !important;
      height: auto !important;
      max-height: calc(100vh - 1rem) !important;
      max-height: calc(100dvh - 1rem) !important;
      border-radius: 10px;
    }
  }
`;

/** @deprecated Prefer ModalConsultGlobalStyle; kept empty for import stability. */
export const ModalStyles = styled.div`
  display: contents;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  width: 100%;
  height: auto;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
`;

export const Header = styled.header`
  flex: 0 0 auto;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 1rem 1.25rem 0.875rem;

  @media (max-width: 767px) {
    padding: 0.875rem 1rem 0.75rem;
  }
`;

export const TitleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding-right: 1.75rem;
`;

export const Title = styled.h3`
  margin: 0;
  color: #1e293b;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.01em;

  @media (max-width: 767px) {
    font-size: 0.95rem;
  }
`;

export const VideoCallBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.75rem;
  padding: 0.4rem 0.75rem;
  border-radius: 999px;
  background: #dd6435;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;

  p {
    margin: 0;
  }
`;

export const Body = styled.div`
  flex: 0 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y pinch-zoom;
  padding: 1rem 1.25rem;
  background: #ffffff;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
  }

  &::-webkit-scrollbar-thumb {
    background: #dd6435;
    border-radius: 3px;
  }

  @media (max-width: 767px) {
    padding: 0.875rem 1rem;
  }
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
  gap: 1rem;
  align-items: start;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 0.875rem;
  }
`;

export const MediaPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  min-width: 0;
`;

export const InfoPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-width: 0;
`;

export const PropertyImage = styled.img`
  display: block;
  width: 100%;
  max-height: min(220px, 28vh);
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f1f5f9;

  @media (max-width: 767px) {
    max-height: min(180px, 26vh);
  }
`;

export const NoPropertyMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: min(160px, 22vh);
  padding: 1rem;
  border-radius: 10px;
  border: 1px dashed #cbd5e1;
  background: #f8fafc;

  p {
    margin: 0;
    color: #64748b;
    font-size: 0.875rem;
    font-weight: 500;
    text-align: center;
  }

  @media (max-width: 767px) {
    min-height: min(130px, 20vh);
  }
`;

export const InfoCard = styled.section`
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  padding: 0.875rem 1rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
`;

export const FieldTitle = styled.h4`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.65rem;
  color: #dd6435;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    background: transparent;
    color: #64748b;
    cursor: pointer;
    padding: 0.15rem;
    border-radius: 4px;

    &:hover {
      color: #dd6435;
      background: #fff7ed;
    }
  }
`;

export const FieldRow = styled.p`
  margin: 0;
  color: #475569;
  font-size: 0.8125rem;
  line-height: 1.45;
  word-break: break-word;

  & + & {
    margin-top: 0.35rem;
  }

  b {
    color: #334155;
    font-weight: 600;
  }

  a {
    color: #dd6435;
    text-decoration: underline;
    text-underline-offset: 2px;

    &:hover {
      color: #c4552b;
    }
  }
`;

export const Footer = styled.footer`
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.875rem 1.25rem;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;
    padding: 0.75rem 1rem;
  }
`;

export const SliderNavigation = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 999px;
    border: 1px solid #e2e8f0;
    background: #ffffff;
    color: #475569;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;

    &:hover:not(:disabled) {
      background: #f1f5f9;
      border-color: #cbd5e1;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  @media (max-width: 767px) {
    order: 2;
  }
`;

export const SliderCounter = styled.span`
  min-width: 3.5rem;
  text-align: center;
  color: #64748b;
  font-size: 0.8125rem;
  font-weight: 600;
`;

export const NoteTextarea = styled.textarea`
  display: block;
  width: 100%;
  min-height: 5.5rem;
  margin-top: 0.35rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  font-size: 0.8125rem;
  line-height: 1.45;
  resize: vertical;

  &::placeholder {
    color: #94a3b8;
  }

  &:focus {
    outline: none;
    border-color: #f97316;
    box-shadow: 0 0 0 1px rgba(249, 115, 22, 0.25);
  }

  &:disabled {
    background: #f8fafc;
    color: #64748b;
    cursor: not-allowed;
  }
`;

export const NoteMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.35rem;

  span {
    color: #94a3b8;
    font-size: 0.6875rem;
  }
`;

export const NoteActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;

  button {
    border: 0;
    border-radius: 8px;
    padding: 0.45rem 0.85rem;
    background: #334155;
    color: #ffffff;
    font-size: 0.75rem;
    font-weight: 700;
    cursor: pointer;
    transition: filter 0.15s ease;

    &:hover:not(:disabled) {
      filter: brightness(0.96);
    }

    &:disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-left: auto;

  > button {
    min-width: 7.5rem;
    border: 0;
    border-radius: 8px;
    padding: 0.65rem 1rem;
    color: #fff;
    font-size: 0.8125rem;
    font-weight: 700;
    cursor: pointer;
    transition: filter 0.15s ease, transform 0.15s ease;

    &:hover {
      filter: brightness(0.96);
    }

    &:active {
      transform: translateY(1px);
    }
  }

  .btn-close {
    background-color: #bf0001;
  }

  .btn-edit {
    background-color: #6ea5ff;
  }

  .btn-create {
    background-color: #dd6435;
  }

  @media (max-width: 767px) {
    width: 100%;
    margin-left: 0;
    order: 1;

    > button {
      flex: 1;
      min-width: 0;
    }
  }
`;
